import SvgDelete from '@common/__generated__/icon/components/SvgDelete';
import { cn } from '@common/utils';
import { Slot } from '@radix-ui/themes';
import { type NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import React from 'react';

import { extractMaxWidthValue } from '../_utils/extractMaxWidthValue';

export const ImageNodeView = ({
  node,
  editor,
  getPos,
  selected,
}: NodeViewProps) => {
  const isEditable = editor.isEditable;
  const src: string = node.attrs.src;
  const href: string | undefined = node.attrs.href;
  const className = node.attrs?.class;
  const styleText = node.attrs?.style ?? '';

  const width = extractMaxWidthValue(styleText);

  const handleDeleteClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const from = getPos();
    const to = from + node.nodeSize;
    editor.chain().deleteRange({ from, to }).run();
  };

  const image = (() => {
    return (
      <img
        alt="editor-img"
        className={cn('w-full', className)}
        draggable={false}
        loading="lazy"
        src={src}
        style={{ maxWidth: width ?? undefined }}
      />
    );
  })();

  return (
    <Slot className="relative w-full">
      <NodeViewWrapper
        as="div"
        className={cn('relative', {
          'ring-2 ring-B-500 ring-offset-2': selected,
          'cursor-pointer': isEditable,
        })}
      >
        {isEditable ? (
          <button
            className="bg-grayscale-black absolute right-12 top-12 flex size-28 items-center justify-center rounded-pill opacity-50"
            type="button"
            onClick={handleDeleteClick}
          >
            <SvgDelete className="text-Gray-white" name="X" />
          </button>
        ) : null}
        {href ? (
          <a
            className="block cursor-pointer"
            href={href}
            rel="noopener noreferrer"
            target="_blank"
            onClick={(e) => isEditable && e.preventDefault()}
          >
            {image}
          </a>
        ) : (
          image
        )}
      </NodeViewWrapper>
    </Slot>
  );
};
